const rouConfig = [
  {
    path: 'reportForm',
    name: 'reportForm',
    meta: {
      name: '报表',
    },
    component: () => import('./reportForm')
  },
 

];

export default rouConfig;